import { createPortal } from 'react-dom';
import styles from './CopyActionSheet.module.scss';

export interface CopyActionSheetProps {
  isOpen: boolean;
  type: 'email' | 'phone' | 'website';
  value: string;
  onClose: () => void;
  onCopy: () => void;
  onAction: () => void;
}

const CopyActionSheet = ({ isOpen, type, value, onClose, onCopy, onAction }: CopyActionSheetProps) => {
  const getActionLabel = () => {
    switch (type) {
      case 'email': return 'EMAIL';
      case 'phone': return 'CALL';
      case 'website': return 'OPEN WEBSITE';
    }
  };
  const getActionSubtext = () => {
    switch (type) {
      case 'email': return 'Opens your email client';
      case 'phone': return 'Opens your phone app';
      case 'website': return 'Opens in new tab';
    }
  };
  const actionLabel = getActionLabel();
  const actionSubtext = getActionSubtext();

  const modalContent = (
    <div style={{ display: isOpen ? 'block' : 'none', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10001, pointerEvents: 'none' }}>
      <div style={{ pointerEvents: 'auto' }}>
        <div className={styles.optsWrapper}>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <div className={styles.headerWrapper}>
              <p style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}>What would you like to do?</p>
            </div>
            <button
              className={styles.btn}
              onClick={() => {
                onCopy();
                onClose();
              }}
            >
              <span>COPY</span>
              <span className={styles.smallText}>{value}</span>
            </button>
            <button
              className={styles.btn}
              onClick={() => {
                onAction();
                onClose();
              }}
            >
              <span>{actionLabel}</span>
              <span className={styles.smallText}>{actionSubtext}</span>
            </button>
          </div>
        </div>
        <div className={styles.cancelWrapper}>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              color: '#000',
              fontSize: '18px',
              borderRadius: '10px',
              border: 'none',
              textAlign: 'center',
              width: '100%'
            }}
          >
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default CopyActionSheet;
